import React from 'react'

const Payment = () => <div>Payment</div>

export default Payment
